import t from "../../app/i18n";

export enum ClientType {
  NATURAL = "NATURAL",
  SELF_EMPLOYED = "SELF_EMPLOYED",
  LEGAL = "LEGAL",
}

export enum ClientRepresentativeFunction {
  LEGAL_REPRESENTATIVE = "LEGAL_REPRESENTATIVE",
  DELEGATE = "DELEGATE",
}

export enum ClientFormType {
  INSURED = "INSURED",
  POLICY_HOLDER = "POLICY_HOLDER",
  REPRESENTATIVE = "REPRESENTATIVE",
  VINCULATION = "VINCULATION",
  HOLDER = "HOLDER",
  OWNER = "OWNER",
  CO_DEBTOR = "CO_DEBTOR",
}

export enum ClientFormStage {
  EMPTY = "EMPTY",
  NEW = "NEW",
  EXISTING = "EXISTING",
  SELECTED = "SELECTED",
}

export enum ClientSearchActionType {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
  CLEAR = "CLEAR",
}

export enum ClientPremiumType {
  FULL = "FULL",
  PARTIAL = "PARTIAL",
  NONE = "NONE",
}

export const clientTypeTMap = new Map<ClientType, string>(
  Object.values(ClientType).map((type) => [
    type,
    `${t("client.enums.type." + type)} ${t("client.helpers.clientTypeLongName." + type)}`,
  ]),
);

export enum CalcValidationGroup {
  CALCULATE = "CALCULATE",
  GENERATE = "GENERATE",
}

export enum ClientIdentityCardType {
  ID_CARD = "ID_CARD",
  EU_ID_CARD = "EU_ID_CARD",
  RESIDENCE_PERMIT = "RESIDENCE_PERMIT",
  EU_RESIDENCE_PERMIT = "EU_RESIDENCE_PERMIT",
  EU_RESIDENCE_PERMIT_FAMILY_MEMBER = "EU_RESIDENCE_PERMIT_FAMILY_MEMBER",
  PASSPORT = "PASSPORT",
}

export enum ClientAgreementType {
  MANDATORY_DOCUMENTS = "MANDATORY_DOCUMENTS",
  ADDITIONAL_DOCUMENTS = "ADDITIONAL_DOCUMENTS",
  BIOMETRY = "BIOMETRY",
  MARKETING = "MARKETING",
  MOBILE = "MOBILE",
  MOBILE_RULES = "MOBILE_RULES",
  MOBILE_MARKETING = "MOBILE_MARKETING",
  MOBILE_ANALYSIS = "MOBILE_ANALYSIS",
}

export enum ClientAttachmentType {
  GENERIC = "GENERIC",
  FRONT_ID_CARD = "FRONT_ID_CARD",
  BACK_ID_CARD = "BACK_ID_CARD",
}

export enum ClientOrderByColumn {
  NAME = "NAME",
  LAST_CONTRACT_DATE = "LAST_CONTRACT_DATE",
  CONTACT_CLIENT_DATE = "CONTACT_CLIENT_DATE",
  CREATED_AT = "CREATED_AT",
}
